"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.9854 5.96621C17.8886 5.61954 17.704 5.30379 17.4496 5.04952C17.1953 4.79525 16.8796 4.61109 16.5334 4.51486C15.2335 4.16676 10.0079 4.16676 10.0079 4.16676C10.0079 4.16676 4.79223 4.15841 3.47881 4.51486C3.13308 4.61151 2.81808 4.79587 2.56427 5.05011C2.31046 5.30436 2.12641 5.61989 2.02992 5.96621C1.78308 7.29921 1.6615 8.65245 1.66679 10.0082C1.66438 11.3574 1.78594 12.704 2.02992 14.0308C2.12672 14.3773 2.31082 14.6931 2.56455 14.9478C2.81827 15.2025 3.1331 15.3876 3.47881 15.4853C4.77869 15.8334 10.0079 15.8334 10.0079 15.8334C10.0079 15.8334 15.2205 15.8334 16.5334 15.4853C16.8796 15.388 17.1951 15.2031 17.4494 14.9484C17.7037 14.6937 17.8882 14.3777 17.9854 14.0308C18.2245 12.7047 18.3412 11.3562 18.3329 10.0082C18.3412 8.65129 18.2271 7.30066 17.9854 5.96621ZM8.33864 12.5064V7.49898L12.6884 10.0082L8.33864 12.5064Z",
    fill: fill
  }));
};

exports["default"] = _default;